import React from "react"

import { graphql } from "gatsby"
import PropTypes from "prop-types"

import CopyContainer from "../components/atoms/copy-container"
import Heading from "../components/atoms/heading"
import Wrapper from "../components/atoms/wrapper"
import Seo from "../components/head"
import Layout from "../components/layout"

const NotFoundPage = ({ data }) => (
  <Layout>
    <Wrapper container>
      <CopyContainer>
        <Heading>{data.sanitySettings.not_found.title}</Heading>
        <CopyContainer content={data.sanitySettings.not_found._rawCopy} />
      </CopyContainer>
    </Wrapper>
  </Layout>
)

export default NotFoundPage

NotFoundPage.propTypes = {
  data: PropTypes.object.isRequired,
}

const HeadComponent = ({ data }) => (
  <Seo title={data.sanitySettings.not_found.title} />
)

HeadComponent.propTypes = {
  data: PropTypes.object.isRequired,
}

export const Head = HeadComponent

export const NotFoundPageQuery = graphql`
  {
    sanitySettings {
      not_found {
        title
        _rawCopy
      }
    }
  }
`
